import { viewTypeEnum } from "@/modules/crm/sales/tasks/helper";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  viewType: viewTypeEnum.view_1,
  calenderViewType: "month",
  /** Persisted calendar navigation date (ISO string); null = use default */
  tasksCalendarDate: null,
  timerRunning: null,
  taskInfo: null,
  isTaskSectionExpanded: false, // Track if inline timer is visible
  draftFields: {},
  commentDraft: {}, // Persists unsent comment text per task id
};

export const tasksSlice = createSlice({
  name: "tasks",
  initialState: { ...initialState },

  reducers: {
    setTasksViewTypeToState: (state, action) => {
      state.viewType = action?.payload;
    },
    setCalendarViewTypeToState: (state, action) => {
      state.calenderViewType = action?.payload;
    },
    setTasksCalendarDate: (state, action) => {
      state.tasksCalendarDate = action.payload || null;
    },
    setTaskInfoToState: (state, action) => {
      if (Object.keys(action?.payload || {}).length) {
        state.timerRunning = action.payload;
        // state.timerRunning[action.payload.taskId] = action.payload;
        // state.taskInfo = action?.payload;
      } else {
        // let data = { ...state?.timerRunning };
        // delete data[action.payload];
        state.timerRunning = null;
        // state.taskInfo = null;
      }
    },
    setTimerRunningInfoToState: (state, action) => {
      state.timerRunning = action?.payload;
    },
    setTaskSectionExpanded: (state, action) => {
      state.isTaskSectionExpanded = action?.payload;
    },
    setTaskDraftField: (state, action) => {
      const { draftKey, data } = action.payload || {};
      if (!draftKey) return;
      state.draftFields[draftKey] = data;
    },
    clearTaskDraftField: (state, action) => {
      const { draftKey } = action.payload || {};
      if (!draftKey) return;
      delete state.draftFields[draftKey];
    },
    clearAllTaskDraftFields: (state) => {
      state.draftFields = {};
    },
    setCommentDraft: (state, action) => {
      const { id, text } = action.payload || {};
      if (!id) return;
      state.commentDraft[id] = text;
    },
    clearCommentDraft: (state, action) => {
      const { id } = action.payload || {};
      if (!id) return;
      delete state.commentDraft[id];
    },
  },
});

export const {
  setTasksViewTypeToState,
  setCalendarViewTypeToState,
  setTasksCalendarDate,
  setTimerRunningInfoToState,
  setTaskInfoToState,
  setTaskSectionExpanded,
  setTaskDraftField,
  clearTaskDraftField,
  clearAllTaskDraftFields,
  setCommentDraft,
  clearCommentDraft,
} = tasksSlice.actions;

/** @returns {string | null} ISO date string */
export const getTasksCalendarDate = (state) => {
  return state.tasks?.tasksCalendarDate ?? null;
};

export const getTasksViewType = (state) => {
  return state.tasks?.viewType;
};
export const getCalendarViewType = (state) => {
  return state.tasks?.calenderViewType;
};
export const getTimerRunning = (key) => (state) => {
  return state.tasks?.timerRunning?.[key];
};
export const getRunningTimer = (state) => {
  return state.tasks?.timerRunning;
};
export const getFirstTimerRunning = (state) => {
  let key = Object.keys(state.tasks?.timerRunning || {})[0];
  return state.tasks?.timerRunning?.[key];
};
export const getAllRunningTimers = (state) => {
  return state.tasks?.timerRunning;
};
export const getTaskInfo = (state) => {
  return state.tasks?.taskInfo;
};
export const getIsTaskSectionExpanded = (state) => {
  return state.tasks?.isTaskSectionExpanded;
};

export const getTaskDraftField = (draftKey) => (state) => {
  return state.tasks?.draftFields?.[draftKey];
};

export const getCommentDraft = (id) => (state) => {
  return state.tasks?.commentDraft?.[id] ?? "";
};

export default tasksSlice.reducer;
